import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AgentSocialLinksDto, AgentSocialLinksUpdateDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-social-links-form',
  imports: [MatIconModule, MatFormFieldModule, MatInputModule],
  templateUrl: './agent-social-links-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentSocialLinksFormComponent {
  readonly links = input<AgentSocialLinksDto | undefined>(undefined);

  readonly linksChange = output<AgentSocialLinksDto>();
  readonly validityChanged = output<boolean>();
  readonly dtoChanged = output<{ dto: AgentSocialLinksUpdateDto; changed: boolean }>();

  readonly internalLinks = signal<AgentSocialLinksDto>({});

  constructor() {
    effect(() => {
      const l = this.links() || {};
      this.internalLinks.set({ ...l });
      this.validityChanged.emit(true);
      this.dtoChanged.emit({
        dto: { socialLinks: l },
        changed: false,
      });
    });
  }

  onChange(field: keyof AgentSocialLinksDto, value: string): void {
    const updated: AgentSocialLinksDto = {
      ...this.internalLinks(),
      [field]: value.trim() || undefined,
    };
    this.internalLinks.set(updated);
    this.linksChange.emit(updated);
    this.validityChanged.emit(true);
    this.dtoChanged.emit({
      dto: { socialLinks: updated },
      changed: true,
    });
  }
}
